module.exports = __webpack_public_path__ + "static/media/AlbopictusLegend.c1f79da8.png";